import { PaymentCard as ApiPaymentCard, PaymentCardCARD_TYPE, PaymentCardFUNDING_TYPE } from '@vendasta/billing';

export interface PaymentCard {
  cardType: PaymentCardTypeLabel;
  fundingType: FundingTypeLabel;
  cardId: string;
  lastFourDigits: string;
  expiryMonth: number;
  expiryYear: number;
  cardholderName?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
  default?: boolean;
}

export enum FundingType {
  PREPAID = 'Pre-paid',
  DEBIT = 'Debit',
  CREDIT = 'Credit',
  UNKNOWN = 'Unknown',
}

export interface FundingTypeLabel {
  value: string;
  id: FundingType;
}

export enum PaymentCardType {
  AMEX = 'American Express',
  VISA = 'Visa',
  MASTERCARD = 'Mastercard',
  JCB = 'JCB',
  DINERS_CLUB = 'Diners Club',
  DISCOVER = 'Discover',
  UNKNOWN = 'Unknown',
}

export interface PaymentCardTypeLabel {
  id: PaymentCardType;
  value: string;
}

const unknownCardType = { id: PaymentCardType.UNKNOWN, value: 'Unknown' };
const paymentCardTypeLabelMap = new Map<PaymentCardCARD_TYPE, PaymentCardTypeLabel>([
  [PaymentCardCARD_TYPE.AMEX, { id: PaymentCardType.AMEX, value: 'American Express' }],
  [PaymentCardCARD_TYPE.VISA, { id: PaymentCardType.VISA, value: 'Visa' }],
  [PaymentCardCARD_TYPE.MASTERCARD, { id: PaymentCardType.MASTERCARD, value: 'Mastercard' }],
  [PaymentCardCARD_TYPE.JCB, { id: PaymentCardType.JCB, value: 'JCB' }],
  [PaymentCardCARD_TYPE.DINERS_CLUB, { id: PaymentCardType.DINERS_CLUB, value: 'Diners Club' }],
  [PaymentCardCARD_TYPE.DISCOVER, { id: PaymentCardType.DISCOVER, value: 'Discover' }],
  [PaymentCardCARD_TYPE.UNKNOWN, unknownCardType],
]);

function convertApiPaymentCardType(t: PaymentCardCARD_TYPE): PaymentCardTypeLabel {
  return paymentCardTypeLabelMap.get(t) || unknownCardType;
}

const unknownFundingType = { id: FundingType.UNKNOWN, value: 'Unknown' };
const fundingTypeLabelMap = new Map<PaymentCardFUNDING_TYPE, FundingTypeLabel>([
  [PaymentCardFUNDING_TYPE.FUNDING_TYPE_DEBIT, { id: FundingType.DEBIT, value: 'Debit' }],
  [PaymentCardFUNDING_TYPE.FUNDING_TYPE_CREDIT, { id: FundingType.CREDIT, value: 'Credit' }],
  [PaymentCardFUNDING_TYPE.FUNDING_TYPE_PREPAID, { id: FundingType.PREPAID, value: 'Pre-paid' }],
  [PaymentCardFUNDING_TYPE.FUNDING_TYPE_UNKNOWN, unknownFundingType],
]);

export function convertApiFundingType(t: PaymentCardFUNDING_TYPE): FundingTypeLabel {
  return fundingTypeLabelMap.get(t) || unknownFundingType;
}

export function convertApiPaymentCardDetails(c: ApiPaymentCard): PaymentCard {
  return {
    cardType: convertApiPaymentCardType(c.cardType),
    fundingType: convertApiFundingType(c.fundingType),
    cardId: c.cardId,
    lastFourDigits: c.lastFourDigits,
    expiryMonth: c.expiryMonth,
    expiryYear: c.expiryYear,
    cardholderName: c.cardholderName,
    address: c.address,
    city: c.city,
    state: c.state,
    country: c.country,
    zipCode: c.zipCode,
    default: c.default,
  } as PaymentCard;
}
